export const getScenarioName = (state) => state.budget.scenarioName;
export const getValid = (state) => state.budget.isValid;
export const getSubmitting = (state) => state.budget.isSubmitting;
export const getRequestingNext = (state) => state.budget.isRequestingNext;
export const getFetching = (state) => state.budget.isFetching;
export const getCallingNextCallback = (state) =>
  state.budget.isCallingNextCallback;
